import moment from 'moment';

export default (data, activity) => {
  const date = moment(data.date || undefined).format('YYYY-MM-DD');

  return {
    id: activity ? activity.id : undefined,

    daily_activity: {
      activity_time: `${date} ${data.time}`,
      data: {
        amount: data.amount,
        desc: data.description,
        bottle_type: data.bottle_type,
        bottle_consumed: data.bottle_consumed
      },
      is_staff_only: data.staffOnly
    }
  };
};
